<template>
  <div
    class="absolute inset-x-0 top-0 high-z w-full h-full bg-secondary flex flex-col items-center"
  >
    <Logo />
    <div class="flex flex-wrap items-stretch items-center justify-center mt-32 w-full">
      <div
        v-for="profile in companyProfiles"
        :key="profile.profile_id"
        class="bg-white shadow overflow-hidden m-12 w-full lg:w-auto"
      >
        <div class="p-6 mb-3">
          <h1 class="text-2xl font-medium text-gray-900">
            {{ profile.name }}
          </h1>
          <p class="mt-4 max-w-2xl text-sm leading-5 text-gray-600 h-5">
            {{ profile.address }}
          </p>
          <p class="max-w-2xl text-sm leading-5 text-gray-600 h-5">
            {{ profile.city }}
          </p>
        </div>
        <div>
          <div
            class="bg-secondary-light px-3 py-3 space-y-6 sm:flex sm:space-y-0 sm:space-x-10 sm:px-8"
          >
            <base-button
              class="w-full"
              :loading="selectedProfileId === profile.id"
              action="select_company"
              @click="selectProfile(profile.id)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {BaseButton} from '@/components/base'
import Logo from '@/components/shared/Logo.vue'

export default {
  data() {
    return {
      selectedProfileId: '',
    }
  },
  computed: {
    companyProfiles() {
      return this.$store.getters['auth/companyProfiles']
    },
  },
  methods: {
    async selectProfile(id) {
      this.selectedProfileId = id
      try {
        await this.$store.dispatch('auth/getProfileForUser', id)
      } catch (error) {
        console.log(error)
      } finally {
        this.selectedProfileId = ''
      }
    },
  },
  components: {
    BaseButton,
    Logo,
  },
}
</script>

<style scoped>
.high-z {
  z-index: 4999;
}
</style>
